import Marquee from "react-fast-marquee";

const words = [
  "climatisation",
  "désinfection",
  "panneaux solaires",
  "gouttières",
  "ramonage",
  "tous travaux",
];

export const EditorialMarquee = () => (
  <section
    className="border-y border-white/10 py-10 md:py-14 overflow-hidden"
    data-testid="editorial-marquee"
  >
    <Marquee speed={25} gradient={false}>
      {words.map((w, i) => (
        <span key={w} className="flex items-center">
          <span
            className={`font-serif text-6xl md:text-8xl tracking-tight mx-8 md:mx-14 ${
              i % 2 === 0 ? "text-hollow" : "text-hollow-gold italic"
            }`}
          >
            {w}
          </span>
          <span className="text-gold text-2xl">—</span>
        </span>
      ))}
    </Marquee>
  </section>
);
